export default __webpack_public_path__ + "static/media/pandas.5e3ec90a.png";